import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getToken, COOKIE_KEYS } from '../../utils/cookies';
import ConsultorioLayout from './ConsultorioLayout';

export default function ConsultorioRouteWrapper() {
  const { user, initialized, isDoctor } = useAuth();
  const location = useLocation();

  if (!initialized) {
    return (
      <div className="d-flex align-items-center justify-content-center min-vh-100">
        <div className="spinner-border text-primary" role="status" aria-label="Espere" />
      </div>
    );
  }
  // Solo exige usuario de sesión; el token puede estar en cookie dpms_* o en memoria tras login.
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!getToken(COOKIE_KEYS.AUTH_TOKEN)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (!isDoctor()) {
    return <Navigate to="/" replace />;
  }
  if (user.must_change_password && user.tenant_id) {
    return <Navigate to="/cambiar-contrasena" replace />;
  }

  return <ConsultorioLayout />;
}
